import React, { memo } from 'react';
import * as Icon from 'ubs-icons';
import { COLOR } from '../../../common/constant';
import { bytesToSize } from '../../../common/function';
import moment from 'moment';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';

const FilePreviewHeader = memo(({ fileName, size, createdAt, onDownload, onRotate, allowRotation, onClose, options, actions, currentFile, subheader, hideDownload, hideFileInfo }) => {
  return (
    <div className="u_fv-preview-header">
      <div className="u_fv-preview-header-left">
        <h4>{fileName || 'File'}</h4>
        {!hideFileInfo && <p>
          {[size ? bytesToSize(size) : null, createdAt ? moment(createdAt).format('DD-MM-YYYY hh:mm A') : null].filter(Boolean).join(' - ')}
        </p>}
      </div>
      <div className="u_fv-preview-header-right">
        {subheader && <div className="u_fv-preview-action-btn">{subheader}</div>}
        {options && options.length > 0 && (
          <Popup
            trigger={
              <div className="u_fv-preview-icon">
                <Icon.VerticalMenu size={20} fill={COLOR.u_white} className="u_m-auto" />
              </div>
            }
            position="bottom right"
            on="click"
            closeOnDocumentClick
            arrow={false}
            nested
            contentStyle={{ zIndex: 9999999, border: 'none', background: 'none', padding: 0, width: 'auto' }}
            overlayStyle={{ zIndex: 9999998 }}
          >
            {close => (
              <div className="u_menu-popover u_animate u_fadeIn u_duration-150">
                <ul className="u_m-0 u_p-0">
                  {options.map((opt, i) => (
                    <li key={i} className="u_rollover-icon-text" onClick={(e) => {
                      e.stopPropagation();
                      opt.onClick?.(currentFile);
                      close();
                    }}>
                      <p>
                        {opt.icon}
                        {opt.label}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </Popup>
        )}
        {actions && actions.map((action, i) => (
          <div key={i} className="u_fv-preview-icon" data-tooltip={action.label} onClick={() => action.onClick?.(currentFile)}>
            <span className="u_m-auto">{action.icon}</span>
          </div>
        ))}
        {allowRotation && (
          <>
            <div className="u_fv-preview-icon" data-tooltip="Rotate Left" onClick={() => onRotate('left')}>
              <Icon.RotateLeft size={18} fill={COLOR.u_white} className="u_m-auto" />
            </div>
            <div className="u_fv-preview-icon" data-tooltip="Rotate Right" onClick={() => onRotate('right')}>
              <Icon.RotateRight size={18} fill={COLOR.u_white} className="u_m-auto" />
            </div>
          </>
        )}
        {!hideDownload && <div className="u_fv-preview-icon" data-tooltip="Download" onClick={onDownload}>
          <Icon.Download size={18} fill={COLOR.u_white} className="u_m-auto" />
        </div>}
        <div className="u_fv-preview-icon u_close-" data-tooltip="Close" onClick={onClose}>
          <Icon.Close size={16} fill={COLOR.u_white} className="u_m-auto" />
        </div>
      </div>
    </div>
  );
});

FilePreviewHeader.propTypes = {
  fileName: PropTypes.string,
  size: PropTypes.number,
  createdAt: PropTypes.string,
  onDownload: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.node,
    onClick: PropTypes.func
  })),
  currentFile: PropTypes.object
};

export default FilePreviewHeader; 
